import { useIsSemDiscoverPage } from "@faire/deprecated-retailer-visitor-shared/lib/useIsSemDiscoverPage";
import { useSettingDiscoverPageSectionalDesign } from "@faire/deprecated-retailer-visitor-shared/settings/useSettingDiscoverPageSectionalDesign";
import { TOP_PRODUCTS_COUNT } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/SearchPageHeaderAndResults/__internal__/DiscoverPageSectionalDesign";
// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { useSearchPageSlicedProducts } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/useSearchPageSlicedProducts";
// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { useDiscoverPageFilteredProductGrids } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/DataFetching/Products/useDiscoverPageFilteredProductGrids";
import { useIsLoggedOutDiscoverPage } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/SearchPageQueryParams/useIsLoggedOutDiscoverPage";
import { useSearchPageFilters } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/SearchPageQueryParams/useSearchPageFilters";
import { useSearchPageZeroIndexedPageNumber } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/SearchPageQueryParams/useSearchPageZeroIndexedPageNumber";

export const useDiscoverPageShouldShowTopProducts = () => {
  const queryProducts = useSearchPageSlicedProducts();
  const page = useSearchPageZeroIndexedPageNumber();
  const filters = useSearchPageFilters();
  const { filteredProductGrids } = useDiscoverPageFilteredProductGrids();
  const discoverPageSectionalDesignV2 = useSettingDiscoverPageSectionalDesign();
  const isLoggedOutDiscoverPage = useIsLoggedOutDiscoverPage();
  const isSemDiscoverPage = useIsSemDiscoverPage();
  return (
    discoverPageSectionalDesignV2 &&
    isLoggedOutDiscoverPage &&
    !isSemDiscoverPage &&
    (queryProducts?.length ?? 0) > TOP_PRODUCTS_COUNT &&
    page === 0 &&
    filters.length === 0 &&
    filteredProductGrids.length > 0
  );
};
